module.exports = __webpack_public_path__ + "static/media/Inter-Bold.45e58f40.woff";